module.exports = __webpack_public_path__ + "static/media/hubspot_icon.787a6010.png";